import React, { useState, useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { UserApi } from "../app/api/user.api";

import { NavBarOne } from '../components/Header';
import { CardH, CardImgCenter, ContainerLeftImg, ImgCardmD, ModelMobile, ModelSoftware } from '../components/Component';
import { Footer } from '../components/Footer';
import Aos from "aos";
import "aos/dist/aos.css";


export function Home()
{
    const [modalState1, setModalState1] = useState(false);
    const [modalState2, setModalState2] = useState(false);

    useEffect( ()=> Aos.init({ duration: 2000 }) , [])

    const user = UserApi();
            
    const getStats = async () => {
        const {data} = await user.getDataStat();
        return data.data;
    };
                 
    const { data } = useQuery({
        queryKey: ["stats"],
        queryFn: getStats,
    });


    return(
        <div className="container-fluid">
            
           <title> Accueil | Samadoc </title>
           <meta name="author" content="Xelkoom-ai" />
           <meta name="keywords" content="document, gestion de fichier, université Sénégalaise , document académique " />
           <meta name="description" content="Samadoc est une plateforme dédiée au partage, à la consultation et à l’organisation de documents académiques, pensée pour offrir une expérience fluide et efficace aux étudiants, enseignants et chercheurs." />

            <div className="row"> 
                {/* ************************************************* */}
                {  modalState1 ? <ModelMobile close={ ()=>{ setModalState1(false) } } /> : null  }

                {/* ************************************************* */}
                {  modalState2 ? <ModelSoftware close={ ()=>{ setModalState2(false) } } /> : null  }
                {/* *************************************************************** */}
                <div className="col-lg-12"> 
                    <div className="row d-flex justify-content-center bg-img-1"> 
                        <div className="col-lg-12"> 
                            <NavBarOne target={'home'} />
                        </div>
                        <div className="col-lg-11"> 
                            <div className="row justify-content-between"> 
                                <div className="col-lg-6 col-md-12 px-4 d-flex align-items-center" data-aos="fade-down" > 
                                    <div className="d-flex flex-column"> 
                                        <img className='icon-60 img-lg center-lg mb-3' src="../img/icons8-student-64.png" alt="samadoc logo" /> 
                                        <h2 className="h2 color-light text-center-lg"> La Plateforme Samadoc </h2>
                                        <h1 className="display-5 bold color-orange text-center-lg mb-3"> la mémoire numérique des académiciens </h1>
                                        <p className="color-light font-lg text-center-lg"> un accès simple, structuré et organisé aux ressources pédagogiques. </p>
                                        <div className='d-flex gap-3 mt-3 flex-center-lg flex-column-sm' > 
                                          <button className="link btn btn-lg btn-light-outline rounded-0" onClick={ ()=>{ setModalState1( !modalState1 ) } }> version mobile </button>
                                          <button className="link btn btn-lg btn-orange-outline rounded-0" onClick={ ()=>{ setModalState2( !modalState2 ) } }> version logicielle </button> 
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 d-flex justify-content-end" data-aos="fade-down"> 
                                    <img className='hide-lg' src="../img/animation.gif" alt="image-illustrative-de-document" /> 
                                </div>
                            </div>
                        </div>                                            
                    </div>
                </div>

                 {/* *************************************************************** */}
                
                <div className="col-lg-12 py-5 bg-orange"> 
                    <div className="row d-flex justify-content-center"> 
                        <div className="col-lg-10">   
                            <div className="row d-flex justify-content-center px-4" data-aos="fade-up"> 
    
                                <div className="col-md-4 my-2"> 
                                    <CardH icon={'bi bi-cloud-upload'} value={ data?.folders } title={'Uploads'} />
                                </div>
                                <div className="col-md-4 my-2"> 
                                    <CardH icon={'bi-person-workspace'} value={ data?.professors } title={'Professeurs'} />
                                </div>
                                <div className="col-md-4 my-2"> 
                                    <CardH icon={'bi-mortarboard'} value={ data?.students } title={'Etudiants'} />
                                </div>

                            </div> 
                        </div>
                    </div>
                </div>

                 {/* *************************************************************** */}

                <div className="col-lg-12 py-5 bg-light border-top border-bottom"> 
                    <div className="row d-flex justify-content-center py-5"> 
                        <div className="col-lg-10 d-flex justify-content-center"> 
                            <div className="d-flex flex-column align-items-center px-4 py-4"> 
                                <p className="text-light bg-dark fs-4 mb-3 py-3 px-5 shadow-sm rounded-5 border"> Optimisation du système </p>
                                <p className="text-muted font-xl mb-2"> Les services en cours de dévéloppement </p>
                            </div>
                        </div>
                        <div className="col-lg-10 mt-5"> 
                            <div className="row px-4" data-aos="fade-up"> 
                                <div className="col-lg-4 col-md-6 mb-4"> 
                                    <CardImgCenter img={'../img/chatbot.jpg'} subTitle={'Projet en cour de développement'} title={'Assistant Intelligent (chatbot)'} link={'/'} btnText={'voir plus'} text={"Pour permettre aux utilisateurs d’interagir avec la plateforme pour rechercher un document ou poser des questions académiques."} /> 
                                </div>
                                <div className="col-lg-4 col-md-6 mb-4"> 
                                    <CardImgCenter img={'../img/ai.jpg'} subTitle={'Projet en cour de développement'} title={'Génération de Notes de Révision'} link={'/'} btnText={'voir plus'} text={"un systeme intelligent pour analyser un cours et générer des fiches de révision synthétisées avec les points clés, des définitions et des schémas explicatifs"} /> 
                                </div>
                                <div className="col-lg-4 col-md-6 mb-4"> 
                                    <CardImgCenter img={'../img/pack.jpg'} subTitle={'Projet en cour de développement'} title={"Pack d'application intégré"} link={'/'} btnText={'voir plus'} text={"Créer un écosystème numérique complet pour toute la communauté éducative. Ces applications, connectées entre elles, faciliteront la collaboration."} /> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ************************************************* */}

                <div className="col-lg-12 bg-img-2 px-0"> 
                    <div className="over-layer py-5 px-4"> 
                        <div className="row d-flex justify-content-center"> 
                            <div className="col-lg-6 col-md-9"> 
                                <div className="d-flex flex-column align-items-center px-4" data-aos="fade-up">
                                    <h1 className='h2 fw-bold text-muted text-center mb-3 mt-5'> PLATEFORME SAMADOC </h1>
                                    <p className='fs-5 text-muted text-center mb-4'> Un moteur de recherche intégré permet de retrouver facilement un document sans devoir parcourir l’ensemble des répertoires. </p>
                                    <div>
                                       <a className="btn btn-lg btn-light border border-dark px-4 py-3" href="/inscription"> Commencez maintenant </a>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ************************************************* */}

                <div className="col-lg-12 py-5 bg-green-dark border-bottom"> 
                    <div className="row d-flex justify-content-center"> 
                        <div className="col-lg-10" data-aos="fade-up"> 
                            < ContainerLeftImg img={'../img/img-groupe-7.png'} title={'Service principale'} text={"Samadoc simplifie l'organisation des ressources académiques et encourage la collaboration entre étudiants et enseignants"} />
                        </div>
                    </div>
                </div>

                {/* ************************************************* */}

                <div className="col-md-12 py-5 bg-light">  
                    <div className="row d-flex justify-content-center px-4 pt-4">  
                        <div className="col-md-10 mt-4">
                            <div className="row bg-orange-light rounded-3 p-4" data-aos="fade-up">
                                {/* ------------------------------------------- */}
                                <div className="col-md-6 mb-4 d-flex align-items-center">
                                    <div className="d-flex flex-column ">
                                        <h2 className="h2 color-green-dark"> Expérience Utilisateur Optimisée </h2>
                                        <p className="fs-5 text-muted"> Notre plateforme de partage de documents académiques est conçue pour offrir une expérience fluide et agréable aux étudiants, professeurs et autres utilisateurs. </p>
                                        <div className='d-flex'>
                                            <a href='/' className="link btn btn-sm btn-green-dark rounded-5 px-3"> Voir plus </a> 
                                         </div>
                                    </div>
                                </div>
                                <div className="col-md-2"> </div>
                                <div className="col-md-4 d-flex justify-content-end">
                                    <div className="d-flex">
                                        <img src="../img/psd-3.png" width={'200px'} height={'180px'} className="align-self-end"  alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* *************************************************************** */}

                <div className="col-lg-12 py-5 bg-light border-bottom"> 
                    <div className="row d-flex justify-content-center"> 
                        <div className="col-lg-10 pt-4 pb-5"> 
                            <div className="row mb-2 px-3" data-aos="fade-up"> 
                                <div className="col-lg-3 col-sm-6 mb-4">
                                    <ImgCardmD img={"../img/icons8-outils-administratifs-64.png"} text={'Accessibilité multi-plateforme '} />
                                </div>
                                <div className="col-lg-3 col-sm-6 mb-4">
                                    <ImgCardmD img={"../img/icons8-outils-administratifs-64.png"} text={'Navigation fluide et simplifié'} />
                                </div>
                                <div className="col-lg-3 col-sm-6 mb-4">
                                    <ImgCardmD img={"../img/icons8-outils-administratifs-64.png"} text={'Stockage sécurisé des fichiers'} />
                                </div>
                                <div className="col-lg-3 col-sm-6 mb-4">
                                    <ImgCardmD img={"../img/icons8-outils-administratifs-64.png"} text={'Controle de gestion des autorisations'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* *************************************************************** */}

                <div className="col-lg-12 bg-green-dark"> 
                    <Footer />
                </div>

            </div>
        </div>
    )
}